import React, { useState } from 'react'
import { styled } from '@mui/material';
import { Button, Card, Checkbox, Col, DatePicker, Flex, message, Modal, Progress, Row, Select, Table, Tag, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import AuthService from '../../Components/auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { vehicleTypes } from '../../Components/common/Constants';
import PalletDrawer from '../../Components/Drawers/PalletDrawer';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, CloudDownloadOutlined, DownloadOutlined, LockFilled, PrinterFilled, SyncOutlined, UnlockFilled } from '@ant-design/icons';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { env } from '../../Components/config';
import { showMessage } from '../../Components/Utils/message';
import LockPackingButton from '../../Components/common/LockPackingButton';
import { useSelector } from 'react-redux';
import { encodeId } from '../../Components/common/CommonFun';
const Auth = new AuthService();
const DataSheet = styled('div')`
    .ant-select .ant-select-selector {
      border-bottom: 1px solidrgb(203, 195, 195);
      border-top: 0px !important;
      border-left: 0px;
      border-right: 0px;
      border-radius: 0px
    }
    .ant-input-disabled {
      background: none;
      color: black;
      fontWeight: 500;
    }
`;

const CardStyled = styled('div')`

    .ant-card-head {
    // background-color: #cfcaca;
    background-color:rgb(52, 133, 246);
    min-height: 30px;
    color: white;
    }
    .ant-card-body {
    padding: 12px;
    background-color:rgb(245, 239, 239);
    }

`;
const RoutePacking = () => {
    const { Option } = Select;
    const { Title } = Typography;
    const { locations, products } = useSelector((state) => state?.AppState?.userCreds);

    const navigate = useNavigate();
    const layoutDispatch = useLoadingDispatch()
    const [deliveryDate, setDeliveryDate] = useState(dayjs());
    const [routes, setRoutes] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [selectedRouteDetails, setSelectedRouteDetails] = useState({
        id: null,
        vehicle_type: null,
        max_pallet: null,
        palet_id: null,
    });
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [palletData, setPalletData] = useState([]);
    const [allRoutePalletData, setAllRoutePalletData] = useState([]);
    const [routeStatusData, setRouteStatusData] = useState([]);
    const [selectedPalletWeight, setSelectedPalletWeight] = useState(0);
    const [lockStatuses, setLockStatuses] = useState('');

    const resetStates = () => {
        setRoutes([]);
        setSelectedRouteDetails({
            id: null,
            vehicle_type: null,
            max_pallet: null,
        })
        setRouteStatusData([]);
        setSelectedRoute(null);
        setAllRoutePalletData([])
    }

    const loadRoutes = async () => {
        resetStates()
        showLoading(layoutDispatch)
        try {
            const routeRes = await Auth.post(`/route/load-locked-routes`, {
                delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
            })
            if (routeRes.ack) {
                setRoutes(routeRes?.routes)
            } else {
                showMessage('error', routeRes?.message)
            }
        } catch (err) {
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const getRoutePackingDetails = async (pallet) => {
        showLoading(layoutDispatch)
        const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
        setSelectedRouteDetails({
            ...selectedRouteDetails,
            palet_id: pallet
        })
        try {
            const res = await Auth.fetch(`/route/route-packing?route_status_id=${selectedRouteDetails.id}&pallet_id=${pallet}&delivery_date=${delivery}`);
            if (res?.ack) {
                const data = res?.route_data || [];
                const updatedItems = data?.map((item) => {
                    const fulfilled = Number(item?.quantity) || 0;
                    const dispatched = Number(item?.packed_quantity) || 0;
                    const picked = Number(item?.picked_quantity) || 0;
                    const alreadypicked = Number(item?.picked_quantity_already) || 0;

                    return {
                        ...item,
                        remaining_quantity: fulfilled - dispatched,
                        remaining_picked_quantity: picked - alreadypicked,
                    };
                });
                setPalletData(updatedItems);

                setDrawerOpen(true);
            } else {
                showMessage('error', res?.message)
            }

        } catch (error) {
            console.log(error);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    }

    const drawerClose = () => {
        setDrawerOpen(false);
        getRouteStatus(selectedRouteDetails.id);
        getRouteData(selectedRouteDetails.id);
        getStatus(selectedRouteDetails.id);
    };

    const getRouteStatus = async (routeId) => {
        const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/route/route-packing-status?route_status_id=${routeId}&delivery_date=${delivery}`);
            console.log("routeStatus", res);
            if (res?.ack) {
                setRouteStatusData(res?.route_data);
            } else {
                setRouteStatusData([]);
            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const getRouteData = async (routeID) => {

        const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/route/route-packing?route_status_id=${routeID}&delivery_date=${delivery}`);
            // console.log("routeStatus", res);
            if (res?.ack) {
                // console.log(res);
                const groupedDataMap = res.route_data.reduce((acc, item) => {
                    const palletId = item.pallet_id;
                    if (!acc[palletId]) {
                        acc[palletId] = [];
                    }
                    acc[palletId].push(item);
                    return acc;
                }, {});

                // Transforming map into desired array format
                const groupedArray = Object.entries(groupedDataMap).map(([pallet_id, palletData]) => ({
                    pallet_id,
                    palletData,
                }));
                setAllRoutePalletData(groupedArray);
                console.log('groupedArray', groupedArray);

            } else {
                setAllRoutePalletData([])

            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const getStatus = async (routeID) => {
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/route/route-status?route_status_id=${routeID}`);
            if (res?.ack) {
                const pickingStatus = res?.route_status?.route_picked_by > 0 ? true : false;
                const packingStatus = res?.route_status?.route_packed_by > 0 ? true : false;

                return {
                    picked: pickingStatus,
                    packed: packingStatus,
                };
            } else {
                return {
                    picked: false,
                    packed: false,
                };
            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
            return {
                picked: false,
                packed: false,
            };
        } finally {
            hideLoading(layoutDispatch);
        }
    };

    const routeChange = async (value) => {
        const status = await getStatus(value);

        if (!status?.picked) {
            showMessage('error', "Route is not picked yet. Try again later");
            return;
        }
        setLockStatuses(status)
        const selectedRoute = routes.find((route) => route.id === value);
        const palletCapacity = vehicleTypes.find((item) => item.id === selectedRoute?.vehicle_type);
        setSelectedRoute(selectedRoute)
        setSelectedRouteDetails({
            ...selectedRouteDetails,
            id: value,
            max_pallet: palletCapacity?.maxPallets,
            routeObj: selectedRoute
        })
        getRouteStatus(value);
        getRouteData(value)
    };

    const handleDownloadAllPalletsPdf = (pallets) => {
        console.log('pallets Download', pallets);

        if (!pallets || pallets.length === 0) {
            message.warning("No pallet data available to download.");
            return;
        }

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const boxHeight = 8;
        const boxWidthLabel = 20;
        const boxWidthValue = 75;
        const startX = 4;
        const headerHeight = 45;

        const drawHeader = (doc, pallet, index) => {
            const rectWidth = 40;
            const qtyX = 4;
            const qtyY = 10;

            doc.setFontSize(10);
            doc.setFont(undefined, 300);
            doc.setDrawColor(0, 0, 0);

            doc.rect(qtyX, qtyY, rectWidth, boxHeight);
            doc.text(`Quantity: ${pallet.total_quantity}`, qtyX + 2, qtyY + 5);

            const weightX = qtyX + rectWidth + 6;
            doc.rect(weightX, qtyY, rectWidth + 9, boxHeight);
            doc.text(`Pallet Weight: ${pallet.pallet_weight?.toFixed(2) || 0} KG`, weightX + 2, qtyY + 5);

            doc.setFontSize(18);
            doc.setFont(undefined, 300);
            doc.text(`Pallet# ${pallet.pallet_id}`, pageWidth - 30, 15);

            let y = 20;
            console.log('Innside Log', deliveryDate, selectedRoute);

            const infoRows = [
                ['Date', deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A'],
                ['Route', selectedRoute?.title || 'N/A'],
                ['Vehicle', selectedRoute?.registration_number || 'N/A'],
                ['Driver', selectedRoute?.driver_name || 'N/A'],
            ];

            doc.setFontSize(11);
            doc.setFont(undefined, 'bold');

            infoRows.forEach(([label, value], idx) => {
                const currentY = y + idx * boxHeight;
                doc.rect(startX, currentY, boxWidthLabel, boxHeight);
                doc.text(label, startX + 2, currentY + boxHeight / 1.5);
                doc.rect(startX + boxWidthLabel, currentY, boxWidthValue, boxHeight);
                doc.setFont(undefined, 'normal');
                doc.text(String(value), startX + boxWidthLabel + 2, currentY + boxHeight / 1.5);
                doc.setFont(undefined, 'bold');
            });

            const listStartX = startX + boxWidthLabel + boxWidthValue + 3;
            const listStartY = y + 3;
            const shopNames = [...new Set(pallet.palletData.map(item =>
                `${item.customer_name} - ${item.customer_project_id}` || '-'
            ))];

            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            shopNames.forEach((name, idx) => {
                const currentY = listStartY + idx * 6;
                doc.text(`${idx + 1}. ${name}`, listStartX, currentY);
            });
        };

        pallets.forEach((pallet, index) => {
            if (index !== 0) doc.addPage();
            drawHeader(doc, pallet, index);

            const headers = [['Shop', 'Item', 'Packed Quantity']];
            const dataRows = pallet.palletData.map(item => [
                `${item.customer_name} - ${item.customer_project_id}`,
                `${item.item_id} - ${item.item_name}`,
                item.packed_quantity || 0
            ]);

            doc.autoTable({
                startY: headerHeight + 10,
                head: headers,
                body: dataRows,
                styles: { fontSize: 9 },
                headStyles: { fillColor: [22, 160, 133] },
                columnStyles: {
                    2: { halign: 'center' }
                },
                margin: { top: headerHeight + 10, left: 4, right: 4 },
                didDrawPage: function () {
                    drawHeader(doc, pallet, index);
                    const pageNumber = doc.internal.getNumberOfPages();
                    doc.setFontSize(10);
                    doc.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
                }
            });
        });

        doc.save(`${selectedRoute?.code}_${dayjs(deliveryDate).format('DD-MM-YYYY')}_${selectedRoute?.registration_number}.pdf`);
    };

    const handlePrintAllPalletLabels = (pallets) => {
        if (!pallets || pallets.length === 0) return;

        const palletHtmlList = pallets.map((pallet, palletIndex) => {
            const { palletData: palletInfo, pallet_id: palletNo, pallet_weight: palletweight } = pallet;

            const shopNames = [
                ...new Set(
                    palletInfo.map(
                        (item) => `${item.customer_name} - ${item.customer_project_id}` || "-"
                    )
                ),
            ];

            const customerListHtml = shopNames
                .map(
                    (name, index) => `<div class="label-row">${index + 1}. ${name}</div>`
                )
                .join("");

            const url =
                env === "prod"
                    ? `https://wms.magnarouting.com/pallet-info/${palletInfo[0]?.pallet_security_code}`
                    : `http://uat.wms.magnarouting.com/pallet-info/${palletInfo[0]?.pallet_security_code}`;

            const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(
                url
            )}`;

            return `
      <div class="page-break">
        <div class="label-container">
          <div class="label-header">
            <img src="https://d35jitumpuemmk.cloudfront.net/assets/Magna_prefectos-logo.png" class="logo" alt="magna" />
            <div class="header-title">PALLET ${palletNo || "N/A"}</div>
          </div>
          <div class="label-info-container">
            <div class="label-info-left">
              <div class="left-label-row"><span class="left-label-title">Date</span><span>${deliveryDate ? dayjs(deliveryDate).format("DD-MM-YYYY") : "N/A"}</span></div>
              <div class="left-label-row"><span class="left-label-title">Route</span><span>${selectedRoute?.title || "N/A"}</span></div>
              <div class="left-label-row"><span class="left-label-title">Vehicle</span><span>${selectedRoute?.registration_number || "N/A"}</span></div>
              <div class="left-label-row"><span class="left-label-title">Driver</span><span>${selectedRoute?.driver_name || "N/A"}</span></div>
            </div>
            <div class="label-info-right">
              <img src="${qrCodeUrl}" alt="QR Code" />
            </div>
          </div>
          <div class="label-box">
            <div class="label-title">Customers</div>
            ${customerListHtml}
          </div>
          <div class="label-box">
            <div class="label-row"><span class="label-title">Pallet Weight</span><span>${palletweight?.toFixed(2) || 0} Kg</span></div>
          </div>
        </div>
      </div>
    `;
        });

        const style = `
    <style>
      @page { size: 148mm 210mm; margin: 0; }
      html, body { margin: 0; padding: 0; width: 148mm; height: auto; font-family: Arial, sans-serif; font-size: 12px; }
      .label-container { box-sizing: border-box; padding: 10px; width: 100%; height: 100%; display: flex; flex-direction: column; gap: 10px; }
      .label-header { display: flex; justify-content: space-between; align-items: center; border: 2px solid black; padding: 6px 10px; background-color: #f0f0f0; }
      .logo { height: 40px; object-fit: contain; }
      .header-title { font-size: 18px; font-weight: bold; text-align: right; }
      .label-info-container { display: flex; flex-direction: row; justify-content: space-between; gap: 10px; }
      .label-info-left { flex: 1.5; border: 1px solid black; padding: 8px; display: flex; flex-direction: column; gap: 4px; }
      .left-label-row { display: flex; align-items: center; }
      .left-label-title { font-weight: bold; width: 60px; flex-shrink: 0; }
      .label-info-right { width: 35%; display: flex; justify-content: center; align-items: center; border: 1px dashed #333; padding: 1px; }
      .label-info-right img { width: 100px; height: 100px; }
      .label-box { border: 1px solid black; padding: 8px; display: flex; flex-direction: column; gap: 4px; }
      .label-row { display: flex; justify-content: space-between; }
      .label-title { font-weight: bold; width: 45%; }
      .page-break { page-break-after: always; }
    </style>
  `;

        // Create iframe
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "0";
        iframe.style.visibility = "hidden";
        document.body.appendChild(iframe);

        // Write content
        iframe.contentDocument.open();
        iframe.contentDocument.write(`
    <html>
      <head><title>Print Pallet Labels</title>${style}</head>
      <body>${palletHtmlList.join("")}</body>
    </html>
  `);
        iframe.contentDocument.close();

        // Print after load
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 1000);
        };
    };


    const DownloadAllRouteInfo = (type) => {
        if (!allRoutePalletData || allRoutePalletData.length === 0) {
            message.warning("No pallet data available to download.");
            return;
        }

        const resultPallets = allRoutePalletData.map(pallet => {
            const matchedStatus = routeStatusData.find(status => status?.pallet_id == pallet?.pallet_id);

            const pallet_weight = matchedStatus?.weight || null;
            const total_quantity = Array.isArray(pallet?.palletData)
                ? pallet?.palletData?.reduce((sum, entry) => sum + (entry?.packed_quantity || 0), 0)
                : 0;

            return {
                ...pallet,
                pallet_weight,
                total_quantity,
            };
        });

        type === 'pdf' ? handleDownloadAllPalletsPdf(resultPallets) : handlePrintAllPalletLabels(resultPallets);
    };


    const routeWeight = routeStatusData.reduce((acc, item) => {
        const weight = item.weight || 0;
        return acc + weight;
    }, 0);
    const routeWeightFormatted = routeWeight.toFixed(2);

    const handleDownloadPdf = (palletInfo, palletNumber, weight) => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const boxWidthLabel = 20;
        const boxWidthValue = 75;
        const boxHeight = 8;
        const startX = 4;

        // This is the vertical space taken by the header section (estimate)
        const headerHeight = 45;

        const drawFullHeader = (doc) => {
            const totalQuantity = palletInfo?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;

            const rectWidth = 40;
            const qtyX = 4;
            const qtyY = 10;

            doc.setFontSize(12);
            doc.setFont(undefined, 300);
            doc.setDrawColor(0, 0, 0);
            doc.rect(qtyX, qtyY, rectWidth, boxHeight, 'D');
            doc.text(`Quantity: ${totalQuantity}`, qtyX + 2, qtyY + 5);

            const weightX = qtyX + rectWidth + 6; // small gap between boxes
            const weightY = qtyY;
            doc.setFontSize(12);
            doc.setFont(undefined, 300);
            doc.rect(weightX, weightY, rectWidth + 9, boxHeight);
            doc.text(`Pallet Weight: ${weight?.toFixed(2) || 0}KG`, weightX + 2, weightY + 5);

            doc.setFontSize(18);
            doc.setFont(undefined, 'bold');
            doc.text(`Pallet# ${palletNumber}`, 180, 15);

            let y = 20;

            const combinedInfo = [
                ['Date', deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A'],
                ['Route', selectedRoute?.title || 'N/A'],
                ['Vehicle', selectedRoute?.registration_number || 'N/A'],
                ['Driver', selectedRoute?.driver_name || 'N/A'],
            ];

            doc.setFontSize(11);
            doc.setFont(undefined, 'bold');

            combinedInfo.forEach(([label, value], index) => {
                const currentY = y + index * boxHeight;

                doc.setDrawColor(0);
                doc.rect(startX, currentY, boxWidthLabel, boxHeight);
                doc.text(label, startX + 2, currentY + boxHeight / 1.5);

                doc.rect(startX + boxWidthLabel, currentY, boxWidthValue, boxHeight);
                doc.setFont(undefined, 'normal');
                doc.text(String(value), startX + boxWidthLabel + 2, currentY + boxHeight / 1.5);

                doc.setFont(undefined, 'bold');
            });

            // Shop names
            const listStartX = startX + boxWidthLabel + boxWidthValue + 3;
            const listStartY = y + 3;
            const shopNames = [...new Set(palletInfo.map(item => `${item.customer_name} - ${item.customer_project_id}` || '-'))];

            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            shopNames.forEach((name, index) => {
                const currentY = listStartY + index * 6;
                // const trimmedName = name.length > 70 ? name.slice(0, 67) + '...' : name;
                doc.text(`${index + 1}. ${name}`, listStartX, currentY);
            });
        };

        const headers = [['Shop', 'Item', 'Quantity']];
        const dataRows = palletInfo.map(item => ([
            `${item.customer_name} - ${item.customer_project_id}` || '-',
            `${item.item_id} - ${item.item_name}` || '-',
            item.quantity || 0,
        ]));

        // Always draw header before table
        drawFullHeader(doc);

        doc.autoTable({
            startY: headerHeight + 10,
            head: headers,
            body: dataRows,
            styles: { fontSize: 9 },
            headStyles: { fillColor: [22, 160, 133] },
            columnStyles: {
                2: { halign: 'center' } // Align 'Quantity' column to the right (3rd column = index 2)
            },
            margin: { top: headerHeight + 10, left: 4, right: 4 },
            didDrawPage: function (data) {
                // Redraw the header on every page before table
                drawFullHeader(doc);

                // Page number at bottom right
                const pageNumber = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
            }
        });

        // const palletNo = selectedRouteDetails?.palet_id || 'N/A';
        doc.save(`${selectedRoute?.code}_${selectedRoute?.registration_number}_${dayjs(deliveryDate).format('DD-MM-YYYY')}_P${palletNumber}.pdf`);
    };

    const handlePrintPalletLabel = (palletInfo, palletNo, palletweight) => {
        console.log('pallets print', palletInfo, palletNo, palletweight);

        const shopNames = [...new Set(palletInfo.map(item => `${item.customer_name} - ${item.customer_project_id}` || '-'))];

        const customerListHtml = shopNames
            .map((name, index) => `<div class="label-row">${index + 1}. ${name}</div>`)
            .join('');
        const qrUrl = `http://localhost:9000/pallet-info/${palletInfo[0]?.pallet_security_code}`
        const url = env === 'prod'
            ? `https://wms.magnarouting.com//pallet-info/${palletInfo[0]?.pallet_security_code}`
            : `http://uat.wms.magnarouting.com/pallet-info/${palletInfo[0]?.pallet_security_code}`;
        const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(url)}`;

        const palletInfoHtml = `
              <div class="label-container">
                <div class="label-header">
                  <img src="https://d35jitumpuemmk.cloudfront.net/assets/Magna_prefectos-logo.png" class="logo" alt="magna" />
                  <div class="header-title">PALLET ${palletNo || 'N/A'}</div>
                </div>
                <div class="label-info-container">
                  <div class="label-info-left">
                    <div class="left-label-row"><span class="left-label-title">Date</span><span>${deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A'}</span></div>
                    <div class="left-label-row"><span class="left-label-title">Route</span><span>${selectedRoute?.title || 'N/A'}</span></div>
                    <div class="left-label-row"><span class="left-label-title">Vehicle</span><span>${selectedRoute?.registration_number || 'N/A'}</span></div>
                    <div class="left-label-row"><span class="left-label-title">Driver</span><span>${selectedRoute?.driver_name || 'N/A'}</span></div>
                  </div>
                  <div class="label-info-right">
                    <img src="${qrCodeUrl}" alt="QR Code" />
                  </div>
                </div>
                <div class="label-box">
                  <div class="label-title">Customers</div>
                  ${customerListHtml}
                </div>
                <div class="label-box">
                  <div class="label-row"><span class="label-title">Pallet Weight</span><span>${palletweight?.toFixed(2) || 0} Kg</span></div>
                </div>
              </div>
            `;

        const style = `
              <style>
                @page { size: 148mm 210mm; margin: 0; }
                html, body { margin: 0; padding: 0; width: 148mm; height: 210mm; font-family: Arial, sans-serif; font-size: 12px; }
                .label-container { box-sizing: border-box; padding: 10px; width: 100%; height: 100%; display: flex; flex-direction: column; gap: 10px; }
                .label-header { display: flex; justify-content: space-between; align-items: center; border: 2px solid black; padding: 6px 10px; background-color: #f0f0f0; }
                .logo { height: 40px; object-fit: contain; }
                .header-title { font-size: 18px; font-weight: bold; text-align: right; }
                .label-info-container { display: flex; flex-direction: row; justify-content: space-between; gap: 10px; }
                .label-info-left { flex: 1.5; border: 1px solid black; padding: 8px; display: flex; flex-direction: column; gap: 4px; }
                .left-label-row { display: flex; align-items: center; }
                .left-label-title { font-weight: bold; width: 60px; flex-shrink: 0; }
                .label-info-right { width: 35%; display: flex; justify-content: center; align-items: center; border: 1px dashed #333; padding: 1px; }
                .label-info-right img { width: 100px; height: 100px; }
                .label-box { border: 1px solid black; padding: 8px; display: flex; flex-direction: column; gap: 4px; }
                .label-row { display: flex; justify-content: space-between; }
                .label-title { font-weight: bold; width: 45%; }
              </style>
            `;

        // Create iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = '0';
        iframe.style.visibility = 'hidden';
        document.body.appendChild(iframe);

        // Write content
        iframe.contentDocument.open();
        iframe.contentDocument.write(`
              <html>
                <head><title>Print Pallet Label</title>${style}</head>
                <body>${palletInfoHtml}</body>
              </html>
            `);
        iframe.contentDocument.close();

        // Print after load
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 1000);
        };
    };

    const DownloadPalletDetails = async (pallet, type, weight) => {
        showLoading(layoutDispatch)
        const delivery = dayjs(deliveryDate).format("YYYY-MM-DD");
        setSelectedRouteDetails({
            ...selectedRouteDetails,
            palet_id: pallet
        })
        try {
            const res = await Auth.fetch(`/route/route-packing?route_status_id=${selectedRouteDetails.id}&pallet_id=${pallet}&delivery_date=${delivery}`);
            if (res?.ack) {
                const palletInfo = res?.route_data;
                if (type === 'print') handlePrintPalletLabel(palletInfo, pallet, weight);
                if (type === 'download') handleDownloadPdf(palletInfo, pallet, weight);
            } else {
                showMessage('error', res?.message)
            }

        } catch (error) {
            console.log(error);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    }

    const notPackedBy = routeStatusData.some(item => Number(item?.pallet_packed_by ?? 0) <= 0);


    const changeRoutePackingStatus = async (type) => {
        showLoading(layoutDispatch);
        const url = type === 1 ? '/route/unlock-route-packing' : '/route/lock-route-packing';
        const dataToSend = {
            route_status_id: selectedRouteDetails?.id,
        }
        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                setLockStatuses({
                    ...lockStatuses,
                    packed: !lockStatuses?.packed
                })
            } else {
                showMessage('error', res?.message);
            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    }

    const lockRoutePacking = async () => {
        showLoading(layoutDispatch);
        const urlPre = `/route/pre-lock-route-packing?route_status_id=${selectedRouteDetails?.id}`;
        const urlLock = '/route/lock-route-packing';
        const dataToSend = {
            route_status_id: selectedRouteDetails?.id,
        };

        try {
            // Step 1: Call pre-lock API
            const preRes = await Auth.fetch(urlPre);

            // Step 2: If ack is false → ask confirmation
            if (!preRes?.ack) {
                hideLoading(layoutDispatch);
                Modal.confirm({
                    title: "Are you sure?",
                    content: "Are you sure you want to lock this route?",
                    okText: "Yes, Lock",
                    cancelText: "Cancel",
                    onOk: async () => {
                        await callLockApi(urlLock, dataToSend);
                    },
                });
                return;
            }

            // Step 3: If ack is true → show popup table
            if (preRes?.ack) {
                hideLoading(layoutDispatch);
                Modal.confirm({
                    title: "Confirm Locking with Unpacked Items",
                    width: '80vw',
                    content: (
                        <>
                            <Table
                                dataSource={preRes.route_unpacked_list}
                                scroll={{ x: 'max-content' }}
                                style={{ marginBottom: 5 }}
                                pagination={false}
                                columns={[
                                    {
                                        title: "Item", render: (record) => {
                                            const item = products?.find((item) => item?.netsuite_id === record?.product_netsuite_id)
                                            return (

                                                <>{`${item?.code} - ${item?.name}`} </>
                                            )
                                        }

                                    },
                                    // { title: "Batch Code", dataIndex: "batch_code" },
                                    { title: "Batch Code", dataIndex: "supplier_batch_code" },
                                    {
              title: "Expiry ",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

                                    { title: "Picked Quantity", dataIndex: "total_quantity_picked" },
                                    { title: "Packed", dataIndex: "total_quantity_packed" },
                                    {
                                        title: "Difference",
                                        render: (record) => {
                                            const diff =
                                                Number(record?.total_quantity_picked || 0) -
                                                Number(record?.total_quantity_packed || 0);
                                            return <Tag color={'red'} style={{ fontSize: 16, fontWeight: 'bold' }}>{diff}</Tag>;
                                        },
                                    },
                                ]}
                            />
                            <hr />
                            <span style={{ fontSize: '18px', marginTop: 4 }}>
                                Items left unpacked will be moved to <b>DEFAULT QUARANTINE</b> location, are you sure to lock packing?
                            </span>
                        </>
                    ),
                    okText: "Lock Packing",
                    cancelText: "Cancel",
                    onOk: async () => {
                        await callLockApi(urlLock, dataToSend);
                    },
                });
            }

        } catch (err) {
            showMessage('error', 'Something went wrong');
        } finally {
            hideLoading(layoutDispatch);
        }
    };

    // helper for final lock call
    const callLockApi = async (url, dataToSend) => {
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                setLockStatuses(prev => ({
                    ...prev,
                    packed: !prev.packed
                }));
                showMessage('success', 'Route locked successfully');
            } else {
                showMessage('error', res?.message);
            }
        } catch {
            showMessage('error', 'Lock request failed');
        } finally {
            hideLoading(layoutDispatch);
        }
    };


    const [showAllPallets, setShowAllPallets] = useState(false);


    return (
        <DataSheet>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
                <h3 style={{ margin: 0 }}>Route Packing</h3>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
            </div>
            <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
                <Flex gap="small" flex={1} style={{ maxWidth: '300px' }}>
                    <DatePicker
                        format={'DD-MM-YYYY'}
                        value={deliveryDate}
                        onChange={(date) => {
                            setDeliveryDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
                        }}
                        placeholder="Select Date"
                        style={{ flex: 1 }}
                    />
                    <Button type="primary" onClick={loadRoutes}>Load Routes</Button>
                </Flex>
                <Flex gap={5} wrap>
                    {
                        allRoutePalletData?.length > 0 && (
                            <>
                                <Button type='primary' icon={<PrinterFilled />} onClick={() => DownloadAllRouteInfo('pdf')}>Download Pallet Sheet</Button>
                                <Button type='primary' icon={<PrinterFilled />} onClick={() => DownloadAllRouteInfo('print')}>Print Labels</Button>

                            </>
                        )
                    }

                </Flex>
            </Flex>

            {routes.length > 0 && (
                <>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                            <Select
                                style={{
                                    width: "100%",
                                    margin: "2px",
                                    fontSize: '14px',
                                    marginTop: '15px'
                                }}
                                showSearch
                                allowClear={false}
                                value={selectedRouteDetails?.id}
                                placeholder="Select Route"
                                onChange={routeChange}
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {routes.slice().sort((a, b) => a.title.localeCompare(b.title)).map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {`${item.title} (${item.code}) - ${item.registration_number} - ${item.driver_name} `}
                                    </Option>
                                ))}
                            </Select>
                        </Col>

                    </Row>
                    <Flex justify='end' style={{ marginTop: 4 }} align='center' gap={5} wrap>
                        {
                            routeStatusData?.length > 0 && (
                                <>
                                    {
                                        selectedRouteDetails?.routeObj?.wms_inventory_adjustment_id > 0 && (
                                            <Tag color='blue' 
                                            style={{ fontSize: '16px', padding: 5, fontWeight: 500, cursor: 'pointer' }}
                                            onClick={()=> navigate(`/transaction-inventory/${encodeId(selectedRouteDetails?.routeObj?.wms_inventory_adjustment_id)}`)}
                                            >Inv. Adjustment: {selectedRouteDetails?.routeObj?.wms_inventory_adjustment_code}</Tag>
                                        )
                                    }
                                    <Tag color='blue' style={{ fontSize: '18px', padding: 5 }}>Route Weight: <span style={{ fontWeight: 'bold' }}>{routeWeightFormatted} KGs</span></Tag>
                                    {
                                        lockStatuses?.packed && (
                                            <Tag color='red' style={{ fontSize: '18px', padding: 5 }}>Packing Locked</Tag>

                                        )
                                    }
                                    <Flex gap={5}>
                                        {lockStatuses?.packed ? (
                                            <Button type='primary' icon={<UnlockFilled />} onClick={() => {
                                                Modal.confirm({
                                                    title: 'Unlock Packing',
                                                    centered: true,
                                                    content: `Are you sure you to unlock packing for this route?`,
                                                    onOk: () => changeRoutePackingStatus(1),
                                                    okText: 'Unlock',
                                                    cancelText: 'Cancel',
                                                    width: 600,
                                                    okButtonProps: { size: "large" },
                                                    cancelButtonProps: { size: "large" },
                                                });
                                            }} >Unlock Packing</Button>
                                        ) : (
                                            <>
                                                <Button danger icon={<LockFilled />}
                                                    onClick={() => {
                                                        if (notPackedBy) {
                                                            showMessage('error', 'Cannot lock route packing. All pallets must be locked.');
                                                            return;
                                                        }
                                                        lockRoutePacking()
                                                        // Modal.confirm({
                                                        //     title: 'Lock Packing',
                                                        //     centered: true,
                                                        //     content: <>

                                                        //         {` Are you sure you to lock packing for this route?`}
                                                        //     </>,
                                                        //     onOk: () => lockRoutePacking(),
                                                        //     okText: 'Lock',
                                                        //     cancelText: 'Cancel',
                                                        //     width: 600,
                                                        //     okButtonProps: { size: "large" },
                                                        //     cancelButtonProps: { size: "large" },
                                                        // });
                                                    }}
                                                >Lock Packing</Button>
                                                {/* <LockPackingButton 
                                        selectedRouteDetails={selectedRouteDetails}
                                        setLockStatuses={setLockStatuses}
                                        lockStatuses={lockStatuses}
                                        notPackedBy={notPackedBy}
                                        /> */}

                                            </>
                                        )}
                                        {/* <Button danger icon={<SyncOutlined />}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'Reset Packing',
                                            centered: true,
                                            content: <>

                                                {` Are you sure you to reset packing for this route?`}
                                            </>,
                                            // onOk: () => changeRoutePackingStatus(2),
                                            okText: 'Reset',
                                            cancelText: 'Cancel',
                                            width: 600,
                                            okButtonProps: { size: "large" },
                                            cancelButtonProps: { size: "large" },
                                        });
                                    }}
                                >Reset Packing</Button> */}
                                    </Flex>
                                </>
                            )
                        }
                    </Flex>
                </>
            )}

            {selectedRouteDetails.max_pallet && (
                <>

                    <Flex justify="end" style={{ marginTop: 12 }}>
                        <Checkbox
                            checked={showAllPallets}
                            style={{ transform: 'scale(1.2)' }}
                            onChange={(e) => setShowAllPallets(e.target.checked)}
                        >
                            Show All Pallets
                        </Checkbox>
                    </Flex>
                    <CardStyled style={{ marginTop: '10px' }}>
                        <Row gutter={[16, 16]}>

                            {Array.from({ length: selectedRouteDetails.max_pallet }).map((_, index) => {
                                // const palletStatus = routeStatusData[index] || {};
                                const palletStatus = routeStatusData.find(p => p.pallet_id === index + 1) || {};

                                console.log('palletStatus', palletStatus);

                                const { total_items = 0, packed_items_count = 0, weight = 0, pallet_packed_by = 0 } = palletStatus;
                                const percent = total_items > 0 ? Math.round((packed_items_count / total_items) * 100) : 0;
                                const isClickable = total_items > 0;
                                // if (!isClickable) return null; 
                                if (!showAllPallets && !isClickable) return null;
                                return (
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12} key={index}>
                                        <Card
                                            onClick={() => {
                                                if (isClickable) {
                                                    setSelectedPalletWeight(weight);
                                                    getRoutePackingDetails(index + 1)
                                                };
                                            }}
                                            style={{
                                                cursor: isClickable ? 'pointer' : 'not-allowed',
                                                opacity: isClickable ? 1 : 0.5,
                                            }}
                                            // title={`Pallet ${index + 1}`}
                                            title={
                                                <Flex justify="space-between" align="center">
                                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>{`Pallet ${index + 1}`}</span>
                                                    {
                                                        isClickable && (
                                                            <>
                                                                {pallet_packed_by > 0 ? (
                                                                    <Tag color="#cd201f">
                                                                        Locked
                                                                    </Tag>
                                                                ) : (
                                                                    <Tag color="green">
                                                                        Open
                                                                    </Tag>
                                                                )}
                                                            </>
                                                        )
                                                    }

                                                </Flex>
                                            }
                                            headStyle={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', padding: '0px 12px' }}
                                            variant="borderless"
                                        >
                                            <Progress
                                                percent={percent}
                                                size="small"
                                                status={percent === 100 ? "success" : "active"}
                                            />
                                            <Flex justify='space-between' align='center' style={{ textAlign: 'center', marginTop: 4, fontSize: 12, color: '#555' }}>
                                                <span>{packed_items_count}/{total_items} Packed</span>
                                                <span> Pallet Weight: {weight?.toFixed(2)} KG</span>
                                                <Flex gap={8}>
                                                    {/* {
                                                    pallet_packed_by > 0 && (
                                                        <Tooltip title={'Packing Locked'} placement="top">
                                                            { }
                                                            <LockFilled
                                                                style={{
                                                                    fontSize: 28, color: 'red',
                                                                }}

                                                            />
                                                        </Tooltip>
                                                    )
                                                } */}

                                                    <Tooltip title={isClickable ? 'Download Details' : null} placement="top">
                                                        <CloudDownloadOutlined
                                                            style={{
                                                                fontSize: 28, color: '#084c8b',
                                                                cursor: isClickable ? 'pointer' : 'not-allowed',
                                                                opacity: isClickable ? 1 : 0.5,
                                                            }}
                                                            onClick={(e) => {
                                                                if (isClickable) {
                                                                    e.stopPropagation();
                                                                    DownloadPalletDetails(index + 1, 'download', weight)
                                                                };

                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title={isClickable ? 'Print Details' : null} placement="top">
                                                        <PrinterFilled
                                                            style={{
                                                                fontSize: 28, color: '#084c8b',
                                                                cursor: isClickable ? 'pointer' : 'not-allowed',
                                                                opacity: isClickable ? 1 : 0.5,
                                                            }}
                                                            onClick={(e) => {
                                                                if (isClickable) {
                                                                    e.stopPropagation();
                                                                    DownloadPalletDetails(index + 1, 'print', weight)
                                                                };

                                                            }}
                                                        />
                                                    </Tooltip>
                                                </Flex>

                                            </Flex>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </CardStyled>
                </>
            )}

            <PalletDrawer drawerOpen={drawerOpen} drawerClose={drawerClose} selectedRouteDetails={selectedRouteDetails} deliveryDate={deliveryDate} selectedRoute={selectedRoute} palletData={palletData} setPalletData={setPalletData} getRouteStatus={getRouteStatus} getRoutePackingDetails={getRoutePackingDetails} selectedPalletWeight={selectedPalletWeight} routeStatusData={routeStatusData} setRouteStatusData={setRouteStatusData} />
        </DataSheet>

    )
}

export default RoutePacking